// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_fA","gallery__header":"c-n_fB","gallery__thumbs":"c-n_fC"};